var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-counterparty-form',{attrs:{"next-step-path":"SelfService-ReportDamage-ThankYou","previous-step-path":"SelfService-ReportDamage-Deadline","create-claim-action":"createLegalClaim"}})}
var staticRenderFns = []

export { render, staticRenderFns }